<template>
  <Dropdown v-model="show" class="mr-3" :class-prop="dropdownClass" :mobile-title="title">
    <template #button>
      <button
        class="whitespace-nowrap rounded bg-gray-light p-3 font-medium hover:text-blue focus:outline-none"
        :class="{ 'text-blue': show || appliedItems.length }"
        @click="show = !show"
      >
        {{ title }}
        <span v-if="appliedItems.length">({{ appliedItems.length }})</span>

        <svg
          class="ml-2 inline-block"
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.11781L1.11781 0L6.88219 5.76438L12.6466 0L13.7644 1.11781L6.88219 8L0 1.11781Z" fill="#4D4D4D" />
        </svg>
      </button>
    </template>

    <CheckboxList :model-value="selectedItems" :items="items" search-placeholder="Search" @update:model-value="i => $emit('update:selectedItems', i)" />

    <template #footer>
      <div class="flex justify-between">
        <button v-if="appliedItems.length" class="letter-sp15 h-10 text-sm font-medium uppercase leading-10" @click="clearFilter">
          Clear All
        </button>
        <div class="grow text-right">
          <button
            class="letter-sp15 h-10 rounded-md bg-blue px-4 text-sm uppercase leading-10 text-white hover:bg-blue-dark md:px-8"
            @click="applyFilter"
          >
            Show
            <span>{{ selectedTotal }}</span>
            {{ $f.pluralize('result', selectedTotal, false) }}
          </button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from '~/components/shared/Dropdown'
import CheckboxList from '~/components/shared/CheckboxList'

export default {
  components: { CheckboxList, Dropdown },

  props: {
    title: { type: String, required: true },
    selectedTotal: { type: Number, required: true },
    items: { type: Array, required: true },
    selectedItems: { type: Array, required: true },
    appliedItems: { type: Array, required: true },
    dropdownClass: { type: String, default: '' },
  },

  emits: ['update:selectedItems', 'update:appliedItems'],

  data: () => ({
    show: false,
  }),

  watch: {
    show (val) {
      if (! val) {
        this.$emit('update:selectedItems', Object.assign([], this.appliedItems))
      }
    },
  },

  methods: {
    applyFilter () {
      this.$emit('update:appliedItems', this.selectedItems)
      this.show = false
    },

    clearFilter () {
      this.$emit('update:selectedItems', [])
      this.$emit('update:appliedItems', [])
      this.show = false
    },
  },
}
</script>
